
export type ImageLinkTreeNodeLinks = Array<number|string>;
export class ImageLinkTreeNode {
    id: string;
    name: string;
    pos = 0;
    isExpanded = false;
    linkNode = false;
    children?: ImageLinkTree = [];
    links?: ImageLinkTreeNodeLinks = [];
}
export type ImageLinkTree = Array<ImageLinkTreeNode>;

export class MsTrees {
    sifaSections: ImageLinkTree = [];
    sifaOtherElements: ImageLinkTree = [];
}

export class ImageLinkTreeFuncs {

    public static addNodeIfNotExists(
        imageLinkTree: ImageLinkTree,
        nodeId: string,
        nodeName: string,
        nodePos: number,
    ): ImageLinkTreeNode {
        let treeNode = this.getNode(imageLinkTree, nodeId);
        if (!treeNode) {
            treeNode = new ImageLinkTreeNode();
            treeNode.id = nodeId;
            treeNode.name = nodeName;
            treeNode.pos = nodePos;
            imageLinkTree.push(treeNode);
        }
        return treeNode;
    }

    public static getNode(imageLinkTree: ImageLinkTree, nodeId: string): ImageLinkTreeNode {
        return imageLinkTree.find(
            function (treeNode: ImageLinkTreeNode) {
                return treeNode.id === nodeId;
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/models/image-link-tree.ts